import { store } from "@/app/store";
import { createLegacyAdapter } from "@/app/legacyAdapter";
import definition from "./definition";

export default createLegacyAdapter(store, definition);
